var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"viewBox":"0 0 24 24"}},_vm.$listeners),[_c('path',{attrs:{"d":"M18.984 6.422l-5.578 5.578 5.578 5.578-1.406 1.406-5.578-5.578-5.578 5.578-1.406-1.406 5.578-5.578-5.578-5.578 1.406-1.406 5.578 5.578 5.578-5.578z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }